import React from "react";
import { parseTable } from "services/AgentChatService";
import UploadTableModalComponent, { UploadTableModalProps } from "../components/UploadTableModal";

type UploadTableModalContainerProps = Omit<UploadTableModalProps, "onParseTable">;

/**
 * Container for UploadTableModal — owns the parseTable service call.
 */
const UploadTableModalContainer: React.FC<UploadTableModalContainerProps> = props => {
  return <UploadTableModalComponent {...props} onParseTable={parseTable} />;
};

export default UploadTableModalContainer;
